var MDB = window.MDB || {};

(function ($) {
    var signalrConnectionPromise = null;

    //https://stackoverflow.com/a/12825546
    var STATE_CONNECTING = 0,
        STATE_CONNECTED = 1,
        STATE_RECONNECTING = 2,
        STATE_DISCONNECTED = 4;
    
    $.extend(MDB,
        {
            configureSignalR: function () {
                var connection = $.connection;
                
                if (!connection || !connection.hub) {
                    console.error("SignalR proxy not available. ");
                    return;
                }
                var hub = $.connection.hub;
                if (!connection.___mdbconfigured) {
                    connection.___mdbconfigured = true;
                    var debug = false;
                    if (document.location) {
                        debug = document.location.hostname === "localhost";
                        if (!debug) {
                            var h = document.location.hash;
                            debug = h.indexOf('#debug') !== -1 || h.indexOf('&debug') !== -1;
                        }
                    }
                    if (debug) {
                        hub.logging = true;
                    }

                    if (!hub.qs) {
                        connection.hub.qs = {};
                    }
                    hub.qs.version = '0.12';

                    hub.disconnected(function () {
                        if (window.console && console.warn) {
                            console.warn('SignalR disconnected: We are currently experiencing difficulties with the connection.');
                        }
                    });
                    hub.connectionSlow(function () {
                        if (window.console && console.warn) {
                            console.warn('SignalR connectionSlow event: We are currently experiencing difficulties with the connection.');
                        }
                    });
                    hub.stateChanged(function (state) {
                        //We'll need to reconnect before starting the next request
                        if(state.newState === STATE_DISCONNECTED){
                            signalrConnectionPromise = undefined;
                        }
                        
                        if (window.console && console.warn) {
                            console.warn('SignalR stateChanged event: ', state);
                        }
                    });
                    hub.error(function (error) {
                        //Allow attempt to restart
                        // if(error.source === 'TimeoutException' && (hub.state === undefined || hub.state === STATE_RECONNECTING || hub.state === STATE_DISCONNECTED)){
                        //     console.log('Disconnected!');
                        //     signalrConnectionPromise = undefined;
                        //     // restartSignalR();
                        // }
                        
                        if (window.console && console.error) {
                            console.error('SignalR error event: ', error);
                        }
                    });

                }
            },
            startSignalR: function () {
                //if(typeof(console) !== 'undefined') console.log("Starting signalR");
                if (!signalrConnectionPromise) {
                    var d = new $.Deferred();
                    signalrConnectionPromise = d.promise();
                    // delay the actual connecting to ensure that all callbacks are setup
                    setTimeout(function () {
                        var opts = {}; //{ transport: ['longPolling' ,'webSockets']};
                        //opts = { transport: ['webSockets', 'serverSentEvents','foreverFrame', 'longPolling'] };
                        opts = { transport: ['serverSentEvents', 'foreverFrame', 'longPolling'] };

                        if (typeof (console) !== 'undefined') {
                            console.log("Starting signalR...");
                        }
                        var connecting = $.connection.hub.start(opts);
                        connecting.done(function () {
                            d.resolve.apply(d, arguments);
                            console.log("SignalR connected, transport = " + (($.connection.hub && $.connection.hub.transport) ? $.connection.hub.transport.name : ''));
                        });
                        connecting.fail(function (err) {
                            d.reject.apply(d, arguments);
                            if (typeof (console) !== 'undefined' && console.warn) {
                                console.warn("Connection failed..." + err);
                            }
                        });
                    }, 10);
                }
                return signalrConnectionPromise;
            },
            
            executeWithSignalR: function(fn){
                return $.Deferred(function(def){
                    //Instantly resolves when we've already started
                    //Reconnect before execution when we've been disconnected
                    MDB.startSignalR().done(function(){
                        var p = fn($.connection);
                        
                        if (p && p.done && p.fail){
                            p.done(function () {
                                def.resolve.apply(def, arguments); 
                            })
                                .fail(function () {
                                    def.reject.apply(def, arguments); 
                                });
                        } else {
                            def.resolve(p);
                        }
                    }).fail(function(){
                        def.reject.apply(d, arguments);
                    });
                }).promise();
            }
        });
    
    
    // function restartSignalR(){
    //     setTimeout(function restartSignalRImpl(){
    //         signalrConnectionPromise = undefined;
    //
    //         MDB.startSignalR().fail(function(){
    //             console.warn('Failed to restart signalR, retrying in 2500 milliseconds');
    //             setTimeout(restartSignalRImpl, 2500);
    //         }).done(function(){
    //             console.log($.connection.___mdbconfigured);
    //             console.info('Successfully reconnected to signalR');
    //            
    //             MDB.configureSignalR();
    //         });
    //     }, 0);
    // }
}(jQuery));